import { pushScopeId, popScopeId, openBlock, createElementBlock, createElementVNode, resolveComponent, createBlock, Fragment, toDisplayString, renderList, createTextVNode, getCurrentInstance, inject, reactive } from 'vue';
import axios from 'axios';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

pushScopeId("data-v-0d8df4bc");
var _hoisted_1 = { class: "cover" };
var _hoisted_2 = /*#__PURE__*/createElementVNode("div", { class: "spinner" }, null, -1 /* HOISTED */);
var _hoisted_3 = [_hoisted_2];
popScopeId();

function render(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1, _hoisted_3);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".spinner[data-v-0d8df4bc] {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 0.72rem;\n  height: 0.72rem;\n}\n.spinner[data-v-0d8df4bc]::after {\n  content: \"\";\n  display: block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 50%;\n  border: 0.06rem solid #ff8800;\n  border-color: #ff8800 transparent #eec89d transparent;\n  animation: spinner-0d8df4bc 1.2s linear infinite;\n}\n@keyframes spinner-0d8df4bc {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}";
styleInject(css_248z);

var script = {};

script.render = render;
script.__scopeId = "data-v-0d8df4bc";
script.__file = "src/components/loading/main.vue";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var script$1 = {
  name: 'gop-partition',
  data: function data() {
    return {
      chList: [],
      isLoading: false,
      noticeMap: {
        tw: {
          title: '請選擇伺服器',
          noCharacter: '此帳號沒有角色',
          logout: '請切換登入帳號',
          understand: '我知道了'
        },
        id: {
          title: 'Pilih karakter',
          noCharacter: 'Akun ini belum memiliki karakter',
          logout: 'Mohon berganti akun',
          understand: 'Konfirmasi'
        },
        th: {
          title: 'เลือกตัวละคร',
          noCharacter: 'บัญชีนี้ไม่มีตัวละครอยู่',
          logout: 'กรุณาเปลี่ยนบัญชี',
          understand: 'ฉันเข้าใจแล้ว'
        },
        sg: {
          title: 'Choose partition',
          noCharacter: 'This account has no characters',
          logout: 'Please switch the account',
          understand: 'I understand'
        }
      },
      region: process.env.REGION
    };
  },

  components: {
    Loading: script
  },
  inject: ['$gop'],
  methods: {
    camelizeStr: function camelizeStr(str) {
      return str.replace(/[_.-](\w|$)/g, function (_, x) {
        return x.toUpperCase();
      });
    },
    convertCase: function convertCase(convertFunc) {
      function converter(thing) {
        if (thing instanceof Array) {
          return thing.map(function (i) {
            return converter(i);
          });
        }
        if (thing instanceof Object) {
          var newObj = {};
          Object.keys(thing).forEach(function (k) {
            newObj[convertFunc(k)] = converter(thing[k]);
          });
          return newObj;
        }
        return thing;
      }
      return converter;
    },
    getCharaters: function getCharaters() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                return _context.abrupt('return', _this.$gop.gopState.characterHandler().then(function (resp) {
                  if (resp.error) {
                    throw Error('GOP Character list API ERR: ' + resp.error);
                  }
                  _this.chList = _this.convertCase(_this.camelizeStr)(resp.characters);
                  return resp;
                }).catch(function (err) {
                  return console.log(err);
                }).finally(function () {
                  return _this.isLoading = false;
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    selectCharacter: function selectCharacter(ch) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$gop.gopState.storage.setItem('partition', ch.partition);
                _this2.$gop.gopState.storage.setItem('role_id', ch.roleId);
                data = void 0;
                _context2.prev = 3;
                _context2.next = 6;
                return _this2.$gop.loginCheck();

              case 6:
                data = _context2.sent;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                data = { error: _context2.t0.message };

              case 12:
                _context2.prev = 12;

                _this2.$emit('start', _extends({}, data, { character: ch }));
                _this2.$gop.gopState.partitionStatus = false;
                return _context2.finish(12);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 9, 12, 16]]);
      }))();
    },
    onFailure: function onFailure() {
      this.$emit('fail');
      this.$gop.gopState.partitionStatus = false;
    }
  },
  created: function created() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getCharaters();

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};

var _hoisted_1$1 = { id: "partition" };
var _hoisted_2$1 = { class: "partition__board" };
var _hoisted_3$1 = { class: "partition_title" };
var _hoisted_4 = {
  class: "partition__list",
  style: { "display": "block" }
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  style: { "display": "block" },
  class: "partition_title"
};
var _hoisted_7 = /*#__PURE__*/createElementVNode("br", null, null, -1 /* HOISTED */);

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Loading = resolveComponent("Loading");

  return openBlock(), createElementBlock("div", _hoisted_1$1, [createElementVNode("div", _hoisted_2$1, [$data.isLoading ? (openBlock(), createBlock(_component_Loading, { key: 0 })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [$data.chList.length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", _hoisted_3$1, toDisplayString($data.noticeMap[$data.region].title), 1 /* TEXT */), createElementVNode("div", _hoisted_4, [(openBlock(true), createElementBlock(Fragment, null, renderList($data.chList, function (ch) {
    return openBlock(), createElementBlock("div", {
      key: "z_" + ch.partition,
      onClick: function onClick($event) {
        return $options.selectCharacter(ch);
      },
      class: "partition__item"
    }, toDisplayString(ch.partitionName) + " " + toDisplayString(ch.roleName), 9 /* TEXT, PROPS */, _hoisted_5);
  }), 128 /* KEYED_FRAGMENT */))])], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createElementVNode("div", _hoisted_6, [createTextVNode(toDisplayString($data.noticeMap[$data.region].noCharacter) + " ", 1 /* TEXT */), _hoisted_7, createTextVNode(" " + toDisplayString($data.noticeMap[$data.region].logout), 1 /* TEXT */)]), createElementVNode("div", {
    class: "partition__back",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onFailure && $options.onFailure.apply($options, arguments);
    })
  }, [createElementVNode("p", null, toDisplayString($data.noticeMap[$data.region].understand), 1 /* TEXT */)])], 64 /* STABLE_FRAGMENT */))], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))])]);
}

var css_248z$1 = "#partition {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  font-size: 20px;\n  color: #999;\n  z-index: 9999;\n  background: rgba(0, 0, 0, 0.5);\n}\n.partition__board {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 300px;\n  background: url(https://dlgarenanow-a.akamaihd.net/mgames/ftmtw/dl/h5/partition/modal_bg_content.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center top;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  min-height: 254px;\n}\n.partition__board::before {\n  content: \"\";\n  position: absolute;\n  top: -1%;\n  left: 0;\n  width: 100%;\n  padding-bottom: 1.7465%;\n  background: url(https://dlgarenanow-a.akamaihd.net/mgames/ftmtw/dl/h5/partition/modal_bg_top.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center top;\n  z-index: 1;\n}\n.partition__board::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding-bottom: 1.7465%;\n  background-color: red;\n  background: url(https://dlgarenanow-a.akamaihd.net/mgames/ftmtw/dl/h5/partition/modal_bg_buttom.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center bottom;\n  z-index: 1;\n}\n.partition_title {\n  font-weight: 500;\n  padding: 10px;\n  color: #ff8800;\n}\n.partition__list {\n  position: relative;\n  background-color: rgba(255, 255, 255, 0.6);\n  width: 270px;\n  max-height: 270px;\n  height: 30%;\n  margin-bottom: 15px;\n  padding: 10px 5px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  border-radius: 10px;\n}\n.partition__item {\n  font-size: 15px;\n  box-sizing: border-box;\n  width: 90%;\n  padding: 10px;\n  margin: 1px 5%;\n  cursor: pointer;\n  border-radius: 20px;\n  color: #ff8800;\n  background-color: rgba(255, 216, 116, 0.25);\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.partition__item:hover {\n  color: #fff;\n  background-color: #ff8800;\n}\n.partition__back {\n  overflow: hidden;\n  border-radius: 20px;\n  width: 50%;\n  display: block;\n  margin: 10px auto;\n  cursor: pointer;\n  background-color: #ff8800;\n  opacity: 1;\n}\n.partition__back:hover {\n  opacity: 0.8;\n}\n.partition__back p {\n  color: #fff;\n  text-align: center;\n  line-height: 20px;\n  padding: 5px;\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__file = "src/components/gop-partition/main.vue";

var _this = undefined;

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator$1(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var defaultOptions = {
  game: 'game',
  storageNamespace: 'gop-authenticate',
  loginHandler: function loginHandler() {
    return Promise.resolve({});
  },
  logoutHandler: function logoutHandler() {
    return Promise.resolve({});
  },
  characterHandler: function characterHandler() {
    return Promise.resolve({});
  },
  storageType: 'cookieStorage',
  devGopHost: 'https://testauth.garena.com',
  gopHost: 'https://auth.garena.com',
  fallbackGopHost: 'https://auth.gopapi.io'
};

var fakeWindow = {
  atob: function atob() {},
  open: function open() {},
  location: {},
  localStorage: {
    setItem: function setItem() {},
    getItem: function getItem() {},
    removeItem: function removeItem() {}
  }
};

var fakeDocument = {
  createElement: function createElement() {},
  body: {
    removeChild: function removeChild() {},
    appendChild: function appendChild() {}
  }
};

var $document = (typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined ? document : fakeDocument;

var $window = typeof window !== 'undefined' ? window : fakeWindow;

var LocalStorage$1 = function LocalStorage(namespace) {
  this.namespace = namespace || null;
};

LocalStorage$1.prototype.setItem = function setItem(key, value) {
  if (value === null || value === undefined) return;
  $window.localStorage.setItem(this.getStorageKey(key), value);
};

LocalStorage$1.prototype.getItem = function getItem(key) {
  return $window.localStorage.getItem(this.getStorageKey(key));
};

LocalStorage$1.prototype.removeItem = function removeItem(key) {
  $window.localStorage.removeItem(this.getStorageKey(key));
};

LocalStorage$1.prototype.getStorageKey = function getStorageKey(key) {
  if (this.namespace) {
    return [this.namespace, key].join('.');
  }
  return key;
};

function formatOptions(options) {
  var path = options.path;
  var domain = options.domain;
  var expires = options.expires;
  var secure = options.secure;
  return [typeof path === 'undefined' || path === null ? '' : ';path=' + path, typeof domain === 'undefined' || domain === null ? '' : ';domain=' + domain, typeof expires === 'undefined' || expires === null ? '' : ';expires=' + expires.toUTCString(), typeof secure === 'undefined' || secure === null || secure === false ? '' : ';secure'].join('');
}

function formatCookie(key, value, options) {
  return [encodeURIComponent(key), '=', encodeURIComponent(value), formatOptions(options)].join('');
}

function parseCookies(str) {
  if (str === void 0) str = '';

  if (str.length === 0) {
    return {};
  }
  var parsed = {};
  var pattern = new RegExp('\\s*;\\s*');
  str.split(pattern).forEach(function (i) {
    var ref = i.split('=');
    var encodedKey = ref[0];
    var encodedValue = ref[1];
    var key = decodeURIComponent(encodedKey);
    var value = decodeURIComponent(encodedValue);
    parsed[key] = value;
  });
  return parsed;
}

var CookieStorage = function CookieStorage(defaultOptions) {
  this._defaultOptions = _extends$1({
    domain: $window.location.hostname,
    expires: null,
    path: '/',
    secure: false
  }, defaultOptions);
};

CookieStorage.prototype.setItem = function setItem(key, value) {
  var options = this._defaultOptions;
  var cookie = formatCookie(key, value, options);
  this._setCookie(cookie);
};

CookieStorage.prototype.getItem = function getItem(key) {
  var cookies = parseCookies(this._getCookie());
  return cookies.hasOwnProperty(key) ? cookies[key] : null;
};

CookieStorage.prototype.removeItem = function removeItem(key) {
  var value = '';
  var defaultOptions = this._defaultOptions;
  var options = _extends$1({}, defaultOptions, {
    expires: new Date(0)
  });
  var cookie = formatCookie(key, value, options);
  this._setCookie(cookie);
};

CookieStorage.prototype._getCookie = function _getCookie() {
  try {
    return $document.cookie === 'undefined' ? '' : $document.cookie;
  } catch (e) {}

  return '';
};

CookieStorage.prototype._setCookie = function _setCookie(cookie) {
  try {
    $document.cookie = cookie;
  } catch (e) {}
};

function StorageFactory(options) {
  switch (options.storageType) {
    case 'localStorage':
      try {
        $window.localStorage.setItem('testKey', 'test');
        $window.localStorage.removeItem('testKey');
        return new LocalStorage$1(options.storageNamespace);
      } catch (e) {}

    case 'cookieStorage':
      return new CookieStorage(options.cookieStorage);
  }
}

function getParam(paramName, url) {
  var href = url || $window.location.href;
  var name = paramName.replace(/[[]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(href);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function removeURLParam(key) {
  var urlparts = $window.location.href.split('?');
  if (urlparts.length >= 2) {
    var prefix = encodeURIComponent(key) + '=';
    var pars = urlparts[1].split(/[&;]/g);
    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    return pars.length > 0 ? urlparts[0] + '?' + pars.join('&') : urlparts[0];
  }
  return urlparts[0];
}

function removeQuery(key) {
  var newUrl = removeURLParam(key);
  $window.history.replaceState({}, $document.title, newUrl);
}

function gopLogout(url) {
  return new Promise(function (resolve, reject) {
    var script = $document.createElement('script');
    script.onload = function () {
      $document.body.removeChild(script);
      resolve();
    };
    script.onerror = function () {
      $document.body.removeChild(script);
      reject();
    };
    script.src = url;
    $document.body.appendChild(script);
  });
}

function clearStorage(storage) {
  storage.removeItem('access_token');
  storage.removeItem('partition');
  storage.removeItem('role_id');
}

function setStorage(storage, _ref) {
  var accessToken = _ref.accessToken,
      partition = _ref.partition,
      roleId = _ref.roleId;

  storage.setItem('access_token', accessToken);
  storage.setItem('partition', partition);
  storage.setItem('role_id', roleId);
}

function setHeaders(game, _ref2) {
  var accessToken = _ref2.accessToken,
      partition = _ref2.partition,
      roleId = _ref2.roleId;

  axios.defaults.headers['Access-Token'] = accessToken;
  if (partition) axios.defaults.headers['Partition'] = partition;
  switch (game.toLowerCase()) {
    case 'ftm':
      if (roleId) axios.defaults.headers['Role-Id'] = roleId;
      var ingameLoginParams = ['channelid', 'gameid', 'ts', 'sig', 'os', 'itopencodeparam'];
      ingameLoginParams = ingameLoginParams.map(function (param) {
        var query = getParam(param);
        return query ? param + '=' + getParam(param) : null;
      });
      var ingameLoginQuery = ingameLoginParams.indexOf(null) !== -1 ? null : ingameLoginParams.join('&');
      if (ingameLoginQuery) {
        axios.defaults.headers['Ingame-Token'] = ingameLoginQuery;
        delete axios.defaults.headers['Access-Token'];
      }
      break;
    case 'mbm':
      axios.defaults.headers['Birth-Partition'] = getParam('birth_partition');
      break;
  }
}

function getInfoFromQuery(game, storage) {
  var accessToken = getParam('access_token') || storage.getItem('access_token');
  var partition = getParam('partition') || storage.getItem('partition');
  var roleId = getParam('roleid') || storage.getItem('role_id');
  var isIngame = false;
  switch (game.toLowerCase()) {
    case 'ftm':
      isIngame = Boolean(getParam('channelid') && getParam('gameid'));
      break;
    case 'codm':
      accessToken = getParam('gop_access_token') || accessToken;
      partition = getParam('areaid') || partition;
      isIngame = Boolean(getParam('areaid'));
      break;
    case 'ff':
      var FreeFire = $window.FreeFire,
          webkit = $window.webkit;

      isIngame = Boolean(FreeFire || webkit && webkit.messageHandlers && webkit.messageHandlers.FreeFire);
      break;
    default:
      isIngame = Boolean(getParam('partition'));
      break;
  }
  storage.setItem('isIngame', storage.getItem('isIngame') === 'true' || isIngame); // ingame 重新整理要維持 ingame 狀態
  return { accessToken: accessToken, partition: partition, roleId: roleId, isIngame: isIngame };
}

function composeQueryString(query) {
  var ret = [];
  for (var key in query) {
    ret.push(key + '=' + encodeURIComponent(query[key]));
  }return ret.join('&');
}

function GopAuthError(message) {
  this.name = 'GopAuthError';
  this.message = message || 'ERROR: GOP Authentication Error';
  this.stack = new Error().stack;
}
GopAuthError.prototype = Object.create(Error.prototype);
GopAuthError.prototype.constructor = GopAuthError;

var activeGopPlugin = void 0;
var gopSymbolKey = '$gop';

function useGop() {
  return getCurrentInstance() && inject(gopSymbolKey) || activeGopPlugin;
}

var VueGopAuthenticate = {
  install: function install(Vue, _ref3) {
    var env = _ref3.env,
        _ref3$opt = _ref3.opt,
        opt = _ref3$opt === undefined ? {} : _ref3$opt;

    var options = _extends$1({}, defaultOptions, opt, { env: env });
    var characterHandler = options.characterHandler;

    var $gop = {};
    var storage = StorageFactory(options);
    Vue.component('gop-partition', script$1);

    $gop.gopState = reactive({
      partitionStatus: false,
      characterHandler: characterHandler,
      storage: storage
    });

    $gop.getLoginUrl = function () {
      var _ref4 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref5$platform = _ref5.platform,
            platform = _ref5$platform === undefined ? 'garena' : _ref5$platform,
            _ref5$allPlatforms = _ref5.allPlatforms,
            allPlatforms = _ref5$allPlatforms === undefined ? 1 : _ref5$allPlatforms,
            _ref5$query = _ref5.query,
            query = _ref5$query === undefined ? {} : _ref5$query,
            _ref5$returnPath = _ref5.returnPath,
            returnPath = _ref5$returnPath === undefined ? '' : _ref5$returnPath;

        var platformMap, gopHostPass, _options$env, GOP_LOCALE, GOP_APP_ID, NODE_ENV, devGopHost, gopHost, fallbackGopHost, _$window$location, protocol, hostname, defaultURI, queryString, redirectURI, host;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                platformMap = {
                  garena: 1,
                  beetalk: 2,
                  facebook: 3,
                  guest: 4,
                  vk: 5,
                  line: 6,
                  huawei: 7,
                  google: 8,
                  apple: 10,
                  twitter: 11
                };
                gopHostPass = false;
                _context2.next = 4;
                return new Promise(function () {
                  var _ref6 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return fetch(options.gopHost + '/images/img_garena_logo.png', { mode: 'no-cors' }).then(function () {
                              return true;
                            }).catch(function () {
                              return false;
                            });

                          case 2:
                            gopHostPass = _context.sent;

                            resolve();

                          case 4:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2) {
                    return _ref6.apply(this, arguments);
                  };
                }());

              case 4:
                _options$env = options.env, GOP_LOCALE = _options$env.GOP_LOCALE, GOP_APP_ID = _options$env.GOP_APP_ID, NODE_ENV = _options$env.NODE_ENV;
                devGopHost = options.devGopHost, gopHost = options.gopHost, fallbackGopHost = options.fallbackGopHost;
                _$window$location = $window.location, protocol = _$window$location.protocol, hostname = _$window$location.hostname;
                defaultURI = encodeURIComponent(protocol + '//' + hostname + '/' + returnPath.replace(/^\//, ''));
                queryString = composeQueryString(query);
                redirectURI = queryString ? defaultURI + '?' + queryString : defaultURI;
                host = NODE_ENV === 'production' ? gopHostPass ? gopHost : fallbackGopHost : devGopHost;
                return _context2.abrupt('return', host + '/oauth/login?client_id=' + GOP_APP_ID + '&redirect_uri=' + redirectURI + '&response_type=token&all_platforms=' + allPlatforms + '&locale=' + GOP_LOCALE + '&platform=' + platformMap[platform]);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function () {
        return _ref4.apply(this, arguments);
      };
    }();

    $gop.loginCheck = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var game, loginHandler, REGION, _getInfoFromQuery, accessToken, partition, roleId, isIngame, needPartitionCheck;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              game = options.game, loginHandler = options.loginHandler, REGION = options.env.REGION;
              _getInfoFromQuery = getInfoFromQuery(game, storage), accessToken = _getInfoFromQuery.accessToken, partition = _getInfoFromQuery.partition, roleId = _getInfoFromQuery.roleId, isIngame = _getInfoFromQuery.isIngame;
              needPartitionCheck = ['ftmtw', 'ftmid', 'ftmth', 'aovtw', 'ftmsg'];

              if (!(!accessToken && !(game.toLowerCase() === 'ftm' && isIngame))) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt('return', new Promise(function (res) {
                return res({ error: 'Missing access token' });
              }));

            case 5:
              setHeaders(game, { accessToken: accessToken, partition: partition, roleId: roleId });
              setStorage(storage, { accessToken: accessToken, partition: partition, roleId: roleId });
              removeQuery('access_token');
              removeQuery('gop_access_token');

              if (!(needPartitionCheck.indexOf([game, REGION].join('').toLowerCase()) !== -1 && !isIngame && !partition)) {
                _context3.next = 12;
                break;
              }

              $gop.gopState.partitionStatus = true;
              return _context3.abrupt('return');

            case 12:
              return _context3.abrupt('return', loginHandler().then(function (resp) {
                if (resp.error) {
                  clearStorage(storage);
                  throw Error(resp.error);
                }
                return resp;
              }));

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    $gop.logoutWithRedirect = function () {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$query = _ref8.query,
          query = _ref8$query === undefined ? {} : _ref8$query,
          _ref8$returnPath = _ref8.returnPath,
          returnPath = _ref8$returnPath === undefined ? '' : _ref8$returnPath,
          _ref8$test = _ref8.test,
          test = _ref8$test === undefined ? false : _ref8$test;

      var logoutHandler = options.logoutHandler;

      var accessToken = storage.getItem('access_token');
      if (!accessToken) return;
      var _$window$location2 = $window.location,
          protocol = _$window$location2.protocol,
          hostname = _$window$location2.hostname;

      var defaultURI = encodeURIComponent(protocol + '//' + hostname + '/' + returnPath.replace(/^\//, ''));
      var queryString = composeQueryString(query);
      var redirectURI = queryString ? defaultURI + '?' + queryString : defaultURI;
      var logoutUrl = 'https://bounce.garena.com/logout?access_token=' + accessToken + '&redirect_url=' + redirectURI;
      if (test) logoutUrl += '&test=1';
      logoutHandler().then(function (resp) {
        if (resp.error) throw Error(resp.error);
        clearStorage(storage);
        $window.location.href = logoutUrl;
      });
    };

    $gop.logout = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var devGopHost, gopHost, env, logoutHandler, accessToken, host;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              devGopHost = options.devGopHost, gopHost = options.gopHost, env = options.env, logoutHandler = options.logoutHandler;
              accessToken = storage.getItem('access_token');

              if (accessToken) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt('return');

            case 4:
              host = env.NODE_ENV === 'production' ? gopHost : devGopHost;

              gopLogout(host + '/oauth/logout?access_token=' + accessToken);
              return _context4.abrupt('return', logoutHandler().then(function (resp) {
                if (resp.error) throw Error(resp.error);
                clearStorage(storage);
                return resp;
              }));

            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    $gop.getAccessToken = function () {
      var accessToken = getParam('gop_access_token') || getParam('access_token') || storage.getItem('access_token');
      if (!accessToken) return;
      storage.setItem('access_token', accessToken);
      removeQuery('access_token');
      removeQuery('gop_access_token');
      return accessToken;
    };

    $gop.isIngame = function () {
      return storage.getItem('isIngame') === 'true';
    };

    Vue.config.globalProperties.$gop = $gop;
    Vue.provide(gopSymbolKey, $gop);
    activeGopPlugin = $gop;
  }
};

export default VueGopAuthenticate;
export { useGop };
